import { createContext, useCallback, useContext, useRef, useState } from 'react'

/**
 * One toast, bottom right, the way the Torahly shell confirms a small action.
 *
 * It says what just happened and goes away. Anything that needs reading stays in the page.
 */

const ToastContext = createContext<(message: string) => void>(() => {})

export function useToast() {
  return useContext(ToastContext)
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState<string | null>(null)
  const [shown, setShown] = useState(false)
  const timer = useRef<number | null>(null)

  const show = useCallback((text: string) => {
    setMessage(text)
    setShown(true)
    if (timer.current) window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setShown(false), 3000)
  }, [])

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className={shown ? 'toast is-on' : 'toast'} role="status" aria-live="polite">
        <i className="ph-fill ph-check-circle" aria-hidden="true" />
        <span>{message}</span>
      </div>
    </ToastContext.Provider>
  )
}
